import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/yerkir-next/src/app/[locale]/real-estate-for-sale/ClientRealEstateForSaleComponent.tsx");
